import { render, staticRenderFns } from "./GarageVehicleCard.vue?vue&type=template&id=2ee90c02"
import script from "./GarageVehicleCard.vue?vue&type=script&lang=js"
export * from "./GarageVehicleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports